class TitleNumberCards {
	constructor(config) {
		this.config = Object.assign({ scope: '.title_number_cards', duration: 2000, buffer: 100 }, config);
		this.$scope = $(this.config.scope);
		if (this.$scope.length) this.init();
	}

	init() {
		this.$scope.find('.animate').each((i, el) => {
			const $el = $(el);
			const check = () => {
				if ($el.data('animated') || !this.inViewport($el)) return;
				$el.data('animated', true);
				this.animate($el);
			};
			check();
			$(window).on('scroll', check);
		});
	}

	inViewport($el) {
		const top = $el.offset().top, h = $el.outerHeight(), b = this.config.buffer;
		const vTop = $(window).scrollTop(), vBot = vTop + $(window).height();
		return (top + h - b > vTop) && (top + b < vBot);
	}

	animate($el) {
		const txt = $el.text().trim();
		const target = parseFloat(txt);

		if (isNaN(target)) return;

		$({ c: 0 }).animate({ c: target }, {
			duration: this.config.duration,
			step: (n) => $el.text(this.format(n, target)),
			complete: () => $el.text(txt)
		});
	}

	format(n, target) {
		const decimals = (target.toString().split('.')[1] || '').length;
		return decimals ? n.toFixed(decimals) : Math.floor(n).toString();
	}
}

export default new TitleNumberCards;